const FOOTER_HEIGHT = 57;

export const useFooterHeight = (): number => {
  return FOOTER_HEIGHT;
};
